import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "../../../components/Forms/FormInputText";
import axios from "../../../config/axios";

const OnlineReservationDeclineDialog = ({
  stayId,
  handleClose,
  handleSubmit,
}) => {
  const formRef = useRef();

  async function submit(values) {
    await axios.post(
      `/api/v1/stays/${stayId}/decline_reservation.json`,
      { cancellation_reason: values.cancellation_reason }
    );
    handleSubmit();
  }

  return (
    <Modal onHide={handleClose} show={true}>
      <Modal.Header closeButton>
        <Modal.Title>Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{ cancellation_reason: "" }}
          enableReinitialize={true}
          onSubmit={submit}
        >
          <Form autoComplete="false">
            <FormInputText
              name={"cancellation_reason"}
              label={"Begründung"}
              hint={"Die Begründung wird dem Gast per E-Mail zugeschickt,"}
            />
          </Form>
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Zurück
        </Button>

        <Button onClick={() => formRef.current.handleSubmit()}>
          Stornieren
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OnlineReservationDeclineDialog;
